import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as sdk from "boa-sdk-ts";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../../../actions/addresses";
import StoreDataOverview from "./storeDataOverview";
import SecretSeedModal from "../sharedComponent/secretSeedModal";
import FeeOption from "../sharedComponent/feeOption";
import {
  WalletMA,
  TxPayloadFee,
  WalletResultCode,
  WalletTxBuilderSingleReceiver,
} from "boa-sdk-ts";
import { amountFormat } from "../../../utils/WalletUtils";
import BoaAddSenderModal from "../sharedComponent/BoaAddSenderModal";
import BalanceSummary from "../sharedComponent/balanceSummary";
import { ErrorCheckUtil } from "../../../utils/ErrorCheckUtil";
import SenderDeleteModal from "../sharedComponent/senderDeleteModal";

const StoreData = (props) => {
  // These are states of current component
  const { t, selectedAddress } = props;
  const [payLoadFee, setPayLoadFee] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const [fee, SetFee] = useState("");

  const [FeeError, SetFeeError] = useState(null);
  const [payLoadError, setPayLoadError] = useState(null);
  const [openConfirmDeletion, setConfirmDeletion] = useState(false);
  const [senderListLoader, setSenderListLoader] = useState(false);
  const [inputPayload, setInputPayload] = useState();

  //refactoring
  const { accounts, builders, client } = WalletMA.instance();
  const [feeOption, setFeeOption] = useState("1");
  const [deletedAccount, setDeletedAccount] = useState();

  const [senderList, setSenderList] = useState([]);
  const [readModeList, setReadModeList] = useState([]);
  const [secretKeyModal, setSecretKeyModal] = useState(false);
  const [transactionOverviewData, setTransactionOverviewData] = useState();

  useEffect(() => {
    console.log("STORE_DATA_INIT");
    initBuilder();
    return () => {
      console.log("STORE_DATA_END");
      const builder = getBuilder();
      if (builder) {
        builder.removeEventListener(
          sdk.Event.CHANGE_BALANCE,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_RECEIVER,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_SENDER,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_TX_FEE,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_PAYLOAD_FEE,
          buildersEventHandler
        );
        builder.removeEventListener(sdk.Event.ERROR, buildersEventHandler);
        builder.clear();
      }
      builders.delete("STORE_DATA");
    };
  }, []);

  const initBuilder = async () => {
    const res = await createBuilder();
    setBuilder(res);
    const account = accounts.selected_account;
    if (account) {
      await res.addSender(account, account.balance.spendable);
    }
  };

  const createBuilder = async () => {
    const builder = new WalletTxBuilderSingleReceiver(client);
    builder.addEventListener(sdk.Event.CHANGE_BALANCE, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_RECEIVER, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_SENDER, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_TX_FEE, buildersEventHandler);
    builder.addEventListener(
      sdk.Event.CHANGE_PAYLOAD_FEE,
      buildersEventHandler
    );
    builder.addEventListener(sdk.Event.ERROR, buildersEventHandler);
    return builder;
  };

  const buildersEventHandler = (e, data) => {
    switch (e) {
      case sdk.Event.CHANGE_BALANCE:
        break;
      case sdk.Event.CHANGE_RECEIVER:
        break;
      case sdk.Event.CHANGE_SENDER:
        const b = getBuilder();
        if (b) {
          setSenderList([...getBuilder().senders.items]);
        }
        break;
      case sdk.Event.CHANGE_TX_FEE:
        SetFee(data);
        break;
      case sdk.Event.CHANGE_PAYLOAD_FEE:
        setPayLoadFee(data);
        break;
      case sdk.Event.ERROR:
        break;
      default:
        break;
    }
  };

  // Reset all properties if account change from navbar.
  useEffect(() => {
    // if show confirm page true and account change then just hide confirm page.
    if (showConfirm) {
      setShowConfirm(false);
    }
    if (selectedAddress) {
      replaceSender();
    }
  }, [selectedAddress]);

  // Change Fee Option Effect
  useEffect(() => {
    if (getBuilder()) {
      getBuilder().setFeeOption(parseFloat(feeOption));
    }
  }, [feeOption]);

  const replaceSender = async () => {
    const b = getBuilder();
    if (b) {
      await b.clearSender(false);
      await b.addSender(
        accounts.selected_account,
        accounts.selected_account.balance.spendable
      );
    }
  };

  const enterPayloadChangeHandler = (e) => {
    // New sender should remove custom fee effect
    const payload = e.target.value;
    setInputPayload(payload);
    if (payload) {
      const isBase64 =
        /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/.test(
          payload
        );
      if (isBase64) {
        const buffer = Buffer.from(payload, "base64");
        if (buffer.length <= TxPayloadFee.TxPayloadMaxSize) {
          setPayLoadError("");
          getBuilder().setPayload(buffer);
        } else {
          setPayLoadError(
            t("Enter_a_valid_payload_length", { length: buffer.length })
          );
          setPayLoadFee(0);
        }
      } else {
        setPayLoadError(t("Enter_a_valid_Base64_format"));
        setPayLoadFee(0);
      }
    } else {
      setPayLoadError("");
      setPayLoadFee(0);
    }
  };

  const onChangeFee = (evt) => {
    //TODO: Change custom Fee
    /*setCustomFeeStatus(true);
    let isDecimal = /^[-+]?[0-9]+\.[0-9]+$/.test(evt.target.value);
    if (isDecimal) {
      let noDigitAfterDecimal = countDecimals(evt.target.value);
      if (noDigitAfterDecimal > 7) {
        evt.preventDefault();
      } else {
        if (evt.keyCode === 8) {
          SetFee(evt.target.value);
        } else {
          SetFee(evt.target.value);
        }
      }
    } else {
      if (evt.keyCode === 8) {
        SetFee(evt.target.value);
      } else {
        if (evt.target.value < 0.01) {
          if (evt.target.value === 0.0 || evt.target.value === 0) {
            SetFee(evt.target.value);
          } else {
            evt.preventDefault();
          }
        } else {
          SetFee(evt.target.value);
        }
      }
    }*/
  };

  // Method to hide confirm div
  const hideConfirmDiv = () => {
    setShowConfirm(false);
  };

  //=======================================
  const secretSeedModalCloseHandler = () => {
    setSecretKeyModal(false);
    if (getBuilder().getReadOnlyAccount().length === 0) {
      getTransactionOverview();
    }
  };

  const getBuilder = () => {
    return builders.get("STORE_DATA");
  };
  const setBuilder = (builder) => {
    builders.set("STORE_DATA", builder);
  };

  // FeeOptionChangeEvent
  const feeOptionChangeHandler = async (e) => {
    setFeeOption(e.target.value);
  };

  // Delete Sender transaction from list
  const deleteSender = (deletedRecord) => {
    setConfirmDeletion(true);
    setDeletedAccount(deletedRecord.account);
  };

  // Method to handletranscation
  const nextTransactionOverview = async (e) => {
    let readModeList = getBuilder().getReadOnlyAccount();
    if (readModeList.length > 0) {
      setReadModeList(readModeList);
      setSecretKeyModal(true);
    } else {
      getTransactionOverview();
    }
  };

  const deleteSenderConfirm = (value) => {
    if (value) {
      const builder = getBuilder();
      builder.removeSender(deletedAccount);
    }
    setDeletedAccount(null);
    setConfirmDeletion(false);
  };

  const getTransactionOverview = async (e) => {
    const builder = getBuilder();
    const res = await builder.getTransactionOverview();
    if (ErrorCheckUtil.resCodeCheck(res) && res.data) {
      setTransactionOverviewData(res.data);
      setShowConfirm(true);
    }
  };

  // Method to send Agora Transaction
  const sendToAgoraTransaction = async () => {
    const builder = getBuilder();
    const tx_res = builder.buildTransaction();

    if (ErrorCheckUtil.resCodeCheck(tx_res)) {
      const tx = tx_res.data;
      const res = await client.sendTransaction(tx);
      if (ErrorCheckUtil.resCodeCheck(res)) {
        props.history.push("/success");
      }
    }
  };

  const addSenderHandler = (account) => {
    if (account) {
      const builder = getBuilder();
      builder.addSender(account, account.balance.spendable);
    }
  };

  return (
    <>
      {/*Store Data Confirmation screen */}
      {showConfirm ? (
        <StoreDataOverview
          hideConfirmDiv={hideConfirmDiv}
          sendToAgoraTransaction={sendToAgoraTransaction}
          transactionOverviewData={transactionOverviewData}
        />
      ) : (
        <div className="Content">
          <div className="TableBg cardBg">
            <div className="ContHeader pendingTable">
              <h3>{t("Input_payload")}</h3>
            </div>
            <div className="store_data">
              <div className="payload_input">
                <textarea
                  rows="20"
                  className="form-control"
                  value={inputPayload}
                  onChange={enterPayloadChangeHandler}
                />
              </div>
              <span className="validText">{payLoadError}</span>
              <div className="payload_fee">
                <p>{t("Payload_Fee")}</p>
                <p>
                  {amountFormat(payLoadFee)}
                  {" BOA"}
                </p>
              </div>
            </div>
          </div>
          {/* Select Fee Option Component */}
          <FeeOption
            fee={fee}
            feeOption={feeOption}
            error={FeeError}
            feeOptionChangeHandler={feeOptionChangeHandler}
          />
          <div className="TableBg cardBg mt-30">
            {/* BOA Add Sender Modal Component */}
            <BoaAddSenderModal
              senderList={senderList}
              senderBtnStatus={
                !(
                  getBuilder() &&
                  getBuilder().remaining &&
                  parseFloat(getBuilder().remaining.toString()) > 0
                )
              }
              remaining={getBuilder() && getBuilder().remaining}
              addSenderHandler={addSenderHandler}
            />
            {/* Sender List Balance Summary Component  */}
            <BalanceSummary
              props={props}
              senderList={senderList}
              deleteSender={deleteSender}
              senderListLoader={senderListLoader}
            />
            <div className="TransactionFee">
              {/* Button to redirect Send BOA transaction screen */}
              <div />
              <button
                className="btn btn-default senderBtn"
                disabled={
                  !(
                    getBuilder() &&
                    getBuilder().validate().code === WalletResultCode.Success
                  )
                }
                color="primary"
                onClick={(e) => nextTransactionOverview(e)}
              >
                {t("NEXT")}
              </button>
            </div>
          </div>
        </div>
      )}
      <SecretSeedModal
        readModeList={readModeList}
        secretKeyModal={secretKeyModal}
        secretSeedModalCloseHandler={secretSeedModalCloseHandler}
      />

      {/* Delete Sender Confirmation Modal  */}
      <SenderDeleteModal
        deleteSenderConfirm={deleteSenderConfirm}
        openConfirmDeletion={openConfirmDeletion}
      />
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StoreData))
);
